export const SKINS = {
  dark: 'dark',
  light: 'light',
  neutral: 'neutral',
} as const;
